import { centsToUSD } from "@campgladiator/cg-common.utility.numbers";

export const getNewMembershipPrice = (
  price: number,
  trialDays: number,
  percentageDiscount?: number,
  amountOff?: number
) => {
  const selectedPriceAmount = price;

  const selectedPriceWithOrWithoutDiscount =
    amountOff && percentageDiscount === 0
      ? selectedPriceAmount - amountOff
      : percentageDiscount > 0
      ? selectedPriceAmount - selectedPriceAmount * (percentageDiscount / 100)
      : selectedPriceAmount;

  const totalDueToday =
    trialDays > 0
      ? centsToUSD(0)
      : centsToUSD(selectedPriceWithOrWithoutDiscount);

  return {
    totalDueToday,
    selectedPriceAmount,
  };
};
